(function () {
  "use strict";

  const DEFAULT_LIMIT = 8;
  const SLIDER_CONFIG = {
    infinite: false,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    swipeToSlide: true,
    slidesToShow: 3.3,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 2.5 } },
      { breakpoint: 750, settings: { slidesToShow: 2.2 } },
      { breakpoint: 577, settings: { slidesToShow: 1.1 } },
    ],
  };

  const PLAY_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
    <path d="M49.666,0A49.984,49.984,0,1,0,99.332,49.983,49.882,49.882,0,0,0,49.666,0m0,94.308A44.326,44.326,0,1,1,93.709,49.983,44.235,44.235,0,0,1,49.666,94.308" fill="#fff"/>
    <path d="M80.923,48.875,34.069,25.3a2.8,2.8,0,0,0-2.735.125A2.83,2.83,0,0,0,30,27.828V74.983a2.833,2.833,0,0,0,1.333,2.407,2.8,2.8,0,0,0,2.735.124L80.923,53.937a2.839,2.839,0,0,0,0-5.062m-45.3,21.531v-38l37.757,19Z" fill="#fff"/>
  </svg>`;

  let earlyMainPromise = window.__newestVideosMainPromise || null;
  let earlyCategoryPromise = window.__newestVideosCategoryPromise || null;

  function getCategories() {
    return window.newestVideosCategories || [];
  }

  function init() {
    const mainWrapper = document.querySelector(
      ".newest-videos-wrapper:not(.category-videos-container)"
    );
    const categoryGroups = document.querySelectorAll(".category-video-group");

    if (!mainWrapper && categoryGroups.length === 0) return;

    if (
      typeof API_URL === "undefined" ||
      typeof API_Header_Options === "undefined"
    ) {
      setTimeout(init, 100);
      return;
    }

    const mainLimit = mainWrapper
      ? parseInt(mainWrapper.dataset.limit) || DEFAULT_LIMIT
      : 0;

    if (mainWrapper) showSkeleton(mainWrapper);

    const requiredCategories = Array.from(categoryGroups).map((group) => {
      const container = group.querySelector(".category-videos-container");
      const categoryLimit = parseInt(group.dataset.limit) || DEFAULT_LIMIT;
      if (container) showSkeleton(container);
      group.style.display = "block";
      return {
        name: group.dataset.category.toLowerCase(),
        element: group,
        container: container,
        limit: categoryLimit,
        videos: [],
      };
    });

    fetchAndRender(mainWrapper, mainLimit, requiredCategories).catch((err) => {
      console.error("Newest videos error:", err);
      if (mainWrapper) mainWrapper.style.display = "none";
      categoryGroups.forEach((el) => (el.style.display = "none"));
    });
  }

  async function fetchAndRender(mainWrapper, mainLimit, requiredCategories) {
    const categories = getCategories();
    const hasMain = !!mainWrapper;
    const hasCategories =
      requiredCategories.length > 0 && categories.length > 0;

    const promises = [];

    if (hasMain) {
      promises.push(earlyMainPromise || fetchVideos(mainLimit));
    }

    if (hasCategories) {
      const categoryLimit = requiredCategories[0]?.limit || DEFAULT_LIMIT;
      const categoryFetchSize = categories.length * categoryLimit;
      promises.push(
        earlyCategoryPromise || fetchVideos(categoryFetchSize, categories)
      );
    }

    const results = await Promise.all(promises);

    if (hasMain) {
      const mainVideos = normalizeVideos(results.shift());
      if (mainVideos.length > 0) {
        renderSlider(mainWrapper, mainVideos.slice(0, mainLimit));
        initSliders();
      } else {
        const inner = document.querySelector(".newest-videos-wrapper-inner");
        if (inner) inner.style.display = "none";
      }
    }

    if (hasCategories) {
      const categoryVideos = normalizeVideos(results.shift());

      categoryVideos.forEach((video) => {
        addVideoToCategories(video, requiredCategories);
      });

      requiredCategories.forEach((cat) => {
        if (cat.videos.length > 0 && cat.container) {
          renderSlider(cat.container, cat.videos.slice(0, cat.limit));
        } else {
          cat.element.style.display = "none";
        }
      });

      initSliders();
    }
  }

  function addVideoToCategories(video, categories) {
    categories.forEach((cat) => {
      if (cat.videos.length >= cat.limit) return;
      const hasCategory = video.categories.some((vc) =>
        vc.translations?.some((t) => t.name.toLowerCase() === cat.name)
      );
      if (hasCategory) cat.videos.push(video);
    });
  }

  function showSkeleton(container) {
    container.innerHTML = `<div class="video-skeleton">
      <div class="video-skeleton__card"></div>
      <div class="video-skeleton__card"></div>
      <div class="video-skeleton__card"></div>
      <div class="video-skeleton__card"></div>
    </div>`;
  }

  function fetchVideos(pageSize, categories = []) {
    const url = new URL(`${API_URL}social-media-posts`);
    const params = new URLSearchParams({
      "filter[source]": "YOUTUBE",
      includes: "newsCategories",
      sort: "-publishedAt",
      "page[number]": 1,
      "page[size]": pageSize,
    });

    if (categories.length > 0) {
      categories.forEach((category) => {
        params.append("filter[newsCategoryName][]", category);
      });
    }

    url.search = params;
    return fetch(url.toString(), API_Header_Options).then((res) => {
      if (!res.ok) throw new Error(`API error: ${res.status}`);
      return res.json();
    });
  }

  function normalizeVideos(response) {
    if (!response?.data) return [];
    return response.data
      .map(({ id, attributes }) => {
        const data = attributes?.[0];
        if (!data?.videoUrl) return null;
        return {
          id: data.id || id,
          title: data.title || "",
          imageUrl: data.imageUrl || defaultPlaceHolder,
          categories: data.newsCategories || [],
        };
      })
      .filter(Boolean);
  }

  function renderSlider(container, videos) {
    const slider = document.createElement("div");
    slider.className = "newest-videos-slider";
    videos.forEach((video) => slider.appendChild(createVideoCard(video)));
    container.innerHTML = "";
    container.appendChild(slider);
  }

  function createVideoCard({ id, title, imageUrl }) {
    const item = document.createElement("div");
    item.className = "collage__item";
    item.innerHTML = `<a class="video-card" href="${window.safeUrl(
      videoPageURL + "/" + id
    )}" aria-label="${escapeHtml(title)}">
      <div class="video-card__media">
        <img src="${window.safeUrl(imageUrl)}" alt="${escapeHtml(title)}" loading="lazy" />
      </div>
      <span class="video-card__play">${PLAY_ICON_SVG}</span>
      <h3 class="video-card__title">${escapeHtml(title)}</h3>
    </a>`;
    return item;
  }

  function initSliders() {
    if (typeof jQuery === "undefined" || typeof jQuery.fn.slick === "undefined")
      return;
    jQuery(".newest-videos-slider:not(.slick-initialized)").each(function () {
      jQuery(this).slick(SLIDER_CONFIG);
    });
  }

  function escapeHtml(str) {
    return window.escapeHtml(str);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
